import React from 'react'
import {SvgIcon, SvgIconProps} from '@mui/material'

const fiiDiiSvg = (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M37.983 24.6896C38.1223 21.8657 37.4033 19.0658 35.9206 16.6584C34.4379 14.2509 32.2611 12.3489 29.6765 11.2025C27.092 10.0561 24.2209 9.71907 21.4412 10.2358C18.6615 10.7526 16.1033 12.0989 14.1035 14.0975C12.1036 16.0962 10.7558 18.6535 10.2374 21.4329C9.71894 24.2124 10.0542 27.0836 11.1991 29.6688C12.3439 32.254 14.2447 34.432 16.6512 35.9162C19.0577 37.4003 21.8572 38.121 24.6812 37.9834C24.6812 37.9834 19.7686 34.6753 17.8726 29.3846M18.0039 18.6154C19.9615 13.2308 24 10.5385 24 10.5385C24 10.5385 28.3953 13.835 29.9358 18.6154M18.0039 18.6154C17.4853 20.0418 17.1128 21.6572 17 23.4615C16.865 25.6222 17.2379 27.6136 17.8726 29.3846M18.0039 18.6154H11.6154M18.0039 18.6154H29.9358M17.8726 29.3846H21.3077M17.8726 29.3846H11.6154M29.9358 18.6154C30.2631 19.6311 30.4615 20.7138 30.4615 21.8462M29.9358 18.6154H36.3846M28.2678 36.9231L23.4217 22.3846L37.9601 27.2308L30.9601 29.9231L28.2678 36.9231Z"
            stroke="currentColor" strokeLinecap="round"/>
    </svg>


)

const FiiDii: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {fiiDiiSvg}
    </SvgIcon>
)

export default FiiDii